/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/bookmark_medium'
export default icon
